import '../common';
import React from 'react';
import ReactDom from 'react-dom';
import Messages from '../common/i18n/Messages';
import MessageDefinitions from './i18n/MessageDefinitions';
import { getLocale } from '../common/i18n/Locale';
import { IntlProvider } from 'react-intl';
import TextResultsForm from './components/TextResultsForm';
import EmailResultsForm from './components/EmailResultsForm';

function render(nodeId, Component, props) {
  const mountNode = document.getElementById(nodeId);
  const messages = Messages.get(MessageDefinitions);

  ReactDom.render(<IntlProvider locale={getLocale()} messages={messages}>
    <Component {...props} />
  </IntlProvider>, mountNode);
}

function renderTextResultsForm(formId, formProp) {
  render(formId, TextResultsForm, formProp ? {form: formProp} : undefined);
}

function unmountTextResultsForm(contactFormId) {
  ReactDom.unmountComponentAtNode(document.getElementById(contactFormId));
}

function renderEmailResultsForm(formId, formProp) {
  render(formId, EmailResultsForm, formProp ? {form: formProp} : undefined);
}

function unmountEmailResultsForm(contactFormId) {
  ReactDom.unmountComponentAtNode(document.getElementById(contactFormId));
}

if (window.ignite) {
  window.ignite.renderTextResultsForm = renderTextResultsForm;

  window.ignite.unmountTextResultsForm = unmountTextResultsForm;

  window.ignite.renderEmailResultsForm = renderEmailResultsForm;

  window.ignite.unmountEmailResultsForm = unmountEmailResultsForm;
}

export {
  renderTextResultsForm,
  unmountTextResultsForm,
  renderEmailResultsForm,
  unmountEmailResultsForm
};



/** WEBPACK FOOTER **
 ** ./src/main/js/social/index.js
 **/